module.exports = __webpack_public_path__ + "media/images/gallery/constellations/variables_layer_on-07f1bea9d566270960a2a7086f8cb724.png";